import { LangLink } from "./LangLink";
import { useLanguage } from "@/lib/language";

export function ResponsibilityNote() {
  const { t } = useLanguage();
  return (
    <section className="ic-section ic-responsibility">
      <div>
        <p className="ic-eyebrow">{t({ en: "Clear responsibilities", ar: "مسؤوليات واضحة" })}</p>
        <h2>
          {t({
            en: "Preparation with your team. Independent decisions.",
            ar: "التحضير مع فريقك. قرارات مستقلة.",
          })}
        </h2>
      </div>
      <div>
        <p>
          {t({
            en: "IraqCert supports management-system preparation and supplier documentation. The certification body audits and decides certification. The buyer decides registration, qualification and acceptance.",
            ar: "تدعم عراق سيرت التحضير لنظام الإدارة وإعداد وثائق المورد. تجري جهة منح الشهادات التدقيق وتتخذ قرار منح الشهادة، وتتخذ الجهة المشترية قرارات التسجيل والتأهيل والقبول.",
          })}
        </p>
        <LangLink to="/about" className="ic-text-link">
          {t({ en: "How the work is delivered", ar: "كيف نعمل معك" })}
        </LangLink>
      </div>
    </section>
  );
}
export function BuyerGuides({ registration = false }: { registration?: boolean }) {
  const { t } = useLanguage();
  const guides = registration
    ? [
        {
          path: "/services/oil-gas-registration/basra-oil-company",
          title: { en: "Basra Oil Company registration", ar: "التسجيل لدى شركة نفط البصرة" },
          text: {
            en: "Review the buyer’s route, evidence and decision points.",
            ar: "راجع مسار الجهة المشترية والأدلة ومراحل القرار.",
          },
        },
        {
          path: "/services/oil-gas-registration/rumaila-avetta",
          title: { en: "Rumaila and the Avetta route", ar: "الرميلة ومسار Avetta" },
          text: {
            en: "Understand registration and what it does not guarantee.",
            ar: "افهم التسجيل وحدود ما يترتب عليه.",
          },
        },
      ]
    : [
        {
          path: "/insights/compare-iso-certification-quotes-iraq",
          title: { en: "Compare ISO quotations", ar: "قارن عروض أسعار الأيزو" },
          text: {
            en: "Compare scope, issuing body, audit work and ongoing costs.",
            ar: "قارن النطاق والجهة المانحة وأعمال التدقيق والتكاليف المستمرة.",
          },
        },
        {
          path: "/insights/iso-certification-scope-activities-sites-iraq",
          title: { en: "Check the certificate scope", ar: "تحقق من نطاق الشهادة" },
          text: {
            en: "Match the activities and sites to the buyer’s actual requirement.",
            ar: "طابق الأنشطة والمواقع مع متطلب الجهة المشترية الفعلي.",
          },
        },
      ];
  return (
    <section
      className="ic-section"
      aria-label={t({ en: "Related buyer guides", ar: "أدلة ذات صلة للمشتري" })}
    >
      <div className="ic-section-heading">
        <h2>{t({ en: "Useful before you commit", ar: "معلومات تفيدك قبل الالتزام" })}</h2>
      </div>
      <div className="ic-service-grid ic-two-columns">
        {guides.map((g) => (
          <LangLink key={g.path} to={g.path} className="ic-service-card">
            <h3>{t(g.title)}</h3>
            <p>{t(g.text)}</p>
            <span className="ic-text-link">{t({ en: "Read the guide", ar: "اقرأ الدليل" })}</span>
          </LangLink>
        ))}
      </div>
    </section>
  );
}
